<app-header></app-header>

<router-outlet></router-outlet>

<app-icons></app-icons>
